export default {
  getConfigList(state) {
    return state.configList;
  },
  getCheckGIBSellerInfoData(state) {
    return state.checkGIBSellerInfoData;
  },
  getNeedPasswordChange(state) {
    return state.needsPasswordChange;
  },
  getInfluencerAdsVisibility(state) {
    return state.checkGIBSellerInfoData?.hideInfluencerAd;
  },
  getIsSupplyAuthorized(state) {
    return state.checkGIBSellerInfoData?.isSupplyAuthorized;
  },
  getIsEarlySettlementActive(state) {
    return state.checkGIBSellerInfoData?.earlySettlementActive;
  },
  getToasterData(state) {
    return state.toasterData;
  },
  getHasImageError(state) {
    return state.hasImageError;
  },
  getHasCustomDealNotification(state) {
    return state.hasCustomDealNotification;
  },
};
